import { GET_AUCTION_FORMS } from "core/apollo/graphql";
import { SEARCH_ACTION_GENERATE_FORM } from "core/consts";
import { getErrorMessage } from "core/model/utils/errors";
import { Auction } from "core/types";
import useSearchAction from "dsl/hooks/useSearchAction";
import { useCallback } from "react";
import { convertEncryptedFieldOut } from "react-forms-state";
import { DocsFormDataMapped } from "..";
import { FORM_NAME_TO_FILE_TYPE, MigratedForms } from "../../utils";
import { useApolloEncryptionContext } from "core/model/patients/encryption/utils";

export const useGetDischargeLetterOnSubmit = ({
  auction,
}: {
  auction: Auction;
}) => {
  const encryptionContext = useApolloEncryptionContext({ decrypt: true });
  const [generateForm, generateFormProgress, resetProgress] = useSearchAction({
    actionType: SEARCH_ACTION_GENERATE_FORM,
    refetchQueries: [
      {
        context: { encryptionContext },
        query: GET_AUCTION_FORMS,
        variables: { auctionId: auction.id },
      },
    ],
  });

  const onSubmit = useCallback(
    async (
      formData: DocsFormDataMapped<MigratedForms>,
      formName: MigratedForms,
    ) => {
      // todo: submit to AI_CORE
      const updatedAuction = {
        ...auction,
        forms: [
          {
            form_data: convertEncryptedFieldOut(JSON.stringify(formData)),
          },
        ],
      } as Auction;
      await generateForm({
        auction,
        context: {
          auction: updatedAuction,
          form_type: FORM_NAME_TO_FILE_TYPE[formName],
        },
        onCompleted: () => {
          resetProgress();
        },
        onError: (err) => {
          console.error(`error saving form - ${getErrorMessage(err)}`);
        },
      });
    },
    [convertEncryptedFieldOut, generateForm, auction],
  );

  return { onSubmit, onSubmitProgress: generateFormProgress };
};
